(function (app) {
    app.constant("lineOfBusinesses",
        [
            { ShortName: "Investment", LongName: "Investment" },
            { ShortName: "Life", LongName: "Life" },
            { ShortName: "Annuity", LongName: "Annuity" },
            { ShortName: "Medicare", LongName: "Medicare" },
            { ShortName: "LTC", LongName: "Long Term Care" }
        ]);
})(window.app); //jshint ignore:line